export default {
	show: false,
	title: '',
	message: '',
	cancelText: '',
	okText: '',
};
